import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { Separator } from '@/Domain/components/Shared/Separator/Separator';
import { TierEnum } from '@/Domain/enum/Tier.enum';
import { SubscriptionHelper } from '@/Domain/helper/Subscription.helper';

type Props = {
  tier: TierEnum;
  canceled: boolean;
  isActivating: boolean;
  onCancelClick: () => void;
  onActivateClick: () => void;
};

export const MembershipCardAction = ({
  tier,
  canceled,
  isActivating,
  onCancelClick,
  onActivateClick,
}: Props) => {
  const { t } = useTranslation('subscription_page');

  if (SubscriptionHelper.isFreeAccount(tier)) {
    return (
      <section className="flex flex-col gap-6 ">
        <Separator />
        <p className="text-sm text-foreground-subtle">
          <Trans
            i18nKey="subscription_page:free_plan_description"
            components={{
              plan: (
                <span className="font-medium text-foreground">
                  {SubscriptionHelper.getTrierLabel(tier)}
                </span>
              ),
            }}
          />
        </p>
      </section>
    );
  }

  if (!canceled) {
    return (
      <Button
        variant="secondary"
        className="text-destructive hover:!bg-destructive-muted/40 hover:!text-destructive"
        onClick={onCancelClick}
      >
        {t('button.cancel_subscription')}
      </Button>
    );
  }

  if (canceled) {
    return (
      // Stays pending until the hook's delayed refetch lands so the button never reads as dead.
      <Button variant="danger" onClick={onActivateClick} disabled={isActivating}>
        {isActivating ? t('button.processing') : t('button.do_not_cancel_subscription')}
      </Button>
    );
  }
};
